import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";

export default function RemindersConfig() {
  const [log, setLog] = useState([]);
  const [msg, setMsg] = useState(""); const [busy, setBusy] = useState(false);
  const load = () => api.get("/reminders/log").then(r => setLog(r.data));
  useEffect(() => { load(); }, []);
  async function test() {
    if (!window.confirm("Send a TEST summary to luke@lwandco.co.nz only? No staff will be emailed.")) return;
    setBusy(true); setMsg("");
    try {
      const { data } = await api.post("/reminders/test-summary");
      setMsg(data.ok ? `Test summary sent to ${data.to} ✓ (${data.would_remind} would be reminded — no staff emailed)` : `Send failed: ${data.error}`);
      load();
    } catch { setMsg("Send failed"); }
    setBusy(false);
  }
  const time = iso => new Date(iso).toLocaleString("en-NZ", { timeZone: "Pacific/Auckland", dateStyle: "short", timeStyle: "short" });
  return (
    <div className="space-y-3" data-testid="reminders-config">
      <div className="card space-y-2">
        <h2 className="text-silver">Monday timesheet reminder</h2>
        <div className="text-sm opacity-80">Runs every Monday at 7:00am NZ time (daylight saving handled). Checks last week Monday–Sunday and emails active workers who are missing a weekday (not on approved leave or a public holiday) or have entries saved but not submitted, then sends Luke one summary. Admins aren't included.</div>
        <button className="btn-silver" disabled={busy} onClick={test} data-testid="btn-test-summary">{busy ? "Sending…" : "Send test summary now"}</button>
        <div className="text-[11px] opacity-60">Test sends ONLY the summary to luke@lwandco.co.nz. It never emails staff.</div>
        {msg && <div className="text-sm" data-testid="test-summary-msg">{msg}</div>}
      </div>
      <div className="card">
        <h2 className="text-silver mb-2">Reminders log</h2>
        <table className="table"><thead><tr><th>Date</th><th>Type</th><th>Recipient</th><th>Missing days</th><th>Status</th></tr></thead>
          <tbody>{log.map(r => (
            <tr key={r.id} data-testid={`rem-log-${r.id}`}>
              <td className="whitespace-nowrap text-xs">{time(r.at)}</td>
              <td className="text-xs">{r.kind === "worker" ? "Reminder" : r.kind === "summary" ? "Summary" : "Test summary"}</td>
              <td className="text-xs">{r.worker_name && r.kind === "worker" ? `${r.worker_name} · ` : ""}{r.recipient}</td>
              <td className="text-xs">{(r.missing_days || []).join(", ")}{r.unsubmitted_days?.length ? ` · not submitted: ${r.unsubmitted_days.join(", ")}` : ""}</td>
              <td className={`text-xs ${r.status === "Sent" ? "text-green-400" : "text-red-400"}`}>{r.status}{r.error ? ` — ${r.error}` : ""}</td>
            </tr>
          ))}
          {log.length === 0 && <tr><td colSpan="5" className="opacity-50">No reminders sent yet.</td></tr>}</tbody></table>
        {log.length > 0 && <div className="text-[11px] opacity-50 mt-1">Latest {log.length} entries · {fmtDate(log[log.length - 1].at)} onward</div>}
      </div>
    </div>
  );
}
